import { render, staticRenderFns } from "./EduCourseCharpterMerterial.vue?vue&type=template&id=aff5b566&scoped=true&"
import script from "./EduCourseCharpterMerterial.vue?vue&type=script&lang=js&"
export * from "./EduCourseCharpterMerterial.vue?vue&type=script&lang=js&"
import style0 from "./EduCourseCharpterMerterial.vue?vue&type=style&index=0&id=aff5b566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff5b566",
  null
  
)

export default component.exports